export default (rowA, rowB, type) => {
  if (rowA.original[type] > rowB.original[type]) return -1
  if (rowB.original[type] > rowA.original[type]) return 1
  return 0
}
